import { Button } from '@mantine/core';
import { Link } from '@inertiajs/react';
import React from 'react';

interface RightAlignedButtonProps {
  user: {
    username: string;
    // other user fields can be added if needed
  };
  href: string;
  label: string;
  style?: React.CSSProperties;
  className?: string;
}

const RightAlignedButton: React.FC<RightAlignedButtonProps> = ({ user, href, label, style, className }) => {
  return (
    <Button component={Link} href={href} style={{ marginLeft: 'auto', ...style }} className={className}>
      {label}
    </Button>
  );
};

export default RightAlignedButton;
